import { useState, useEffect } from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import axios from 'axios';
import { BACKEND_URL } from '../../../utils/config';

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!connectedAccountId) return;

    const initializeStripeConnect = async () => {
      try {
        const token = localStorage.getItem('token');
        
        // Fetch client secret from backend
        const response = await axios.post(
          `${BACKEND_URL}/api/stripe/account-session`,
          { account: connectedAccountId },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status !== 200) {
          throw new Error('Failed to initialize Stripe Connect');
        }

        const { client_secret: clientSecret } = response.data;

        // Initialize Stripe Connect
        const stripeConnect = await loadConnectAndInitialize({
          publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
          fetchClientSecret: async () => clientSecret,
          appearance: {
            overlays: 'dialog',
            variables: {
              colorPrimary: '#14b8a6', // brand-teal
              colorBackground: '#ffffff',
              colorText: '#1f2937', // gray-800
              fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
              fontSizeBase: '14px',
              borderRadius: '6px',
              spacingUnit: '4px',
            },
            elements: {
              button: {
                backgroundColor: '#14b8a6',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#0d9488', // brand-teal-dark
                },
              },
              input: {
                borderColor: '#e5e7eb',
                '&:focus': {
                  borderColor: '#14b8a6',
                },
              },
            },
          },
        });

        setStripeConnectInstance(stripeConnect);
      } catch (err) {
        console.error('Error initializing Stripe Connect:', err);
        setError(err.message);
      }
    };

    initializeStripeConnect();
  }, [connectedAccountId]);

  return stripeConnectInstance;
};

export default useStripeConnect; 